import { render } from "./Declaration.vue?vue&type=template&id=6b5311d4"
import script from "./Declaration.vue?vue&type=script&lang=js"
export * from "./Declaration.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre-agemi/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__